<template>
    <div id="layout_component" class="layout-component">
        <header class="layout-header" v-if="!$route.meta.hideHeader && auth">
            <layout-header></layout-header>
        </header>
        <section class="layout-section">
            <router-view :auth="auth"></router-view>
        </section>
        <alert></alert>
        <buy-packet></buy-packet>
        <withdraw-coins-modal></withdraw-coins-modal>
        <autologout-component v-if="auth"></autologout-component>
    </div>
</template>

<script>
    import LayoutHeader from './partials/LayoutHeader.vue'

    //Modals
    import Alert from './partials/section/modals/Alert.vue'
    import BuyPacket from './partials/section/modals/BuyPacket.vue'
    import WithdrawCoinsModal from './partials/section/modals/WithdrawCoinsModal.vue'

    export default {
        components: { Alert, BuyPacket, LayoutHeader, WithdrawCoinsModal },
        computed: {
            auth () {
                return this.$store.getters.checkAuth
            }
        }
    }
</script>

<style lang="scss">
    @import '../../assets/scss/_colors.scss';
    @import '../../assets/scss/_buttons.scss';
    @import '../../assets/scss/_forms.scss';
    @import '../../assets/scss/_headers.scss';
    @import '../../assets/scss/_modal.scss';
    @import '../../assets/scss/_shapes.scss';
    @import '../../assets/scss/_tables.scss';

    body{
        background-image: url('../../assets/img/bg.png');
        background-position: center top;
        background-size: 100%;
        background-repeat: no-repeat;
        padding-bottom: 40px;
        min-width: 320px;
        min-height: 100vh;

        @media(max-width: 767px){
            padding-bottom: 0;
        }
    }

    .layout-component{
        display: block;
        width: 100%;
        max-width: 1130px;
        min-width: 320px;
        margin: 0 auto;
        padding: 36px 0;

        @media(max-width: 991px){
            margin: 0 auto;
            padding-bottom: 40px;
        }
    }

    .section-menu-title{
        height: 95px;
        border-bottom: 1px solid #00b1b9;
        margin-bottom: 30px;

        h3{
            font-size: 24px;
            font-weight: bold;
            color: $base1;
            text-transform: uppercase;
        }
    }

    @media(max-width: 991px){
        .section-menu{
            display: block;
            flex: auto;
            position: absolute;
            top: 120px;
            left: 15px;
            max-width: 100%;
            width: calc(100% - 30px);
            height: calc(100% - 85px);
            padding: 0 0 64px;
            background: white;
            z-index: 9;
            padding-left: 10px;
        }

        .section-menu:not(.active){
            height: 1px;
            opacity: 0;
            overflow: hidden;
        }

        .content-active{
            opacity: 0;
        }
    }

    .button--progress{
        color: rgba(0, 0, 0, 0) !important;
        background-image: url('../../assets/img/spinner.svg');
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        cursor: default !important;
    }

    .data-loader{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: url('../../assets/img/spinner-dark.svg');
        background-position: center 30px;
        background-repeat: no-repeat;
        background-size: 60px;
        background-color: rgba(255, 255, 255, 0.6);
        z-index: 2;

        &__block{
             position: relative;
             width: 60px;
             height: 60px;
             background-size: cover;
             background-position: center;
        }

        &__modal{
            background-position: center;
        }

        &__inline{
            position: relative;
            display: inline-block;
            width: 30px;
            height: 30px;
            background-image: url('../../assets/img/spinner.svg');
            background-color: rgba(0, 0, 0, 0);
            background-size: cover;
            background-position: center;
        }


    }

    table{
        .calendar-icon{
            position: relative;
            display: inline-block;
            vertical-align: middle;
            width: auto;
            height: auto;

            p{
                display: inline-block;
                vertical-align: middle;
            }

            i{
                display: inline-block;
                vertical-align: middle;
                font-size: 25px;
                line-height: 25px;
                color: $d-gray;
                cursor: pointer;
                transition: 200ms all linear;
            }

            .flatpickr-input{
                padding: 0 !important;
                z-index: 5 !important;
            }
        }

        .datepicker{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 1;
            cursor: pointer;
            opacity: 0;
            overflow: hidden;

            .control{
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                overflow: hidden;

                input{
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    padding: 0;
                    z-index: 3;
                }

                i{
                    display: none;
                }
            }
        }
    }

    .flatpickr-day{
        &.endRange,
        &.endRange.nextMonthDay,
        &.endRange.prevMonthDay,
        &.endRange:focus,
        &.endRange:hover,
        &.selected,
        &.selected.nextMonthDay,
        &.selected.prevMonthDay,
        &.selected:focus,
        &.selected:hover,
        &.startRange,
        &.startRange.nextMonthDay,
        &.startRange.prevMonthDay,
        &.startRange:focus,
        &.startRange:hover{
             background: $base1 !important;
             border-color: $base1 !important;
        }
    }

    .sort-icon{
        position: relative;
        display: inline-block;
        vertical-align: middle;
        height: 25px;
        width: 25px;
        cursor: pointer;

        i{
            position: absolute;
            left: 0;
            font-size: 16px;
            line-height: 15px;
            color: $d-gray;
            transition: 200ms all linear;

            &.mdi-chevron-up{
                 top: 0;
            }

            &.mdi-chevron-down{
                 bottom: 0;
            }
        }
    }

    .filter-icon {
        position: relative;
        display: inline-block;
        vertical-align: middle;
        height: 25px;
        width: 25px;
        cursor: pointer;

        i {
            position: absolute;
            bottom: 4px;
            left: 0;
            font-size: 20px;
            line-height: 15px;
            color: $d-gray;
            transition: 200ms all linear;
        }
    }

    @media(min-width: 992px){
        .mobile-only{
            display: none !important;
        }
    }

    @media(max-width: 991px){
        .desktop-only{
            display: none !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/Layout.vue